import type { Locale } from '@seek/melways-sites';
import { Text } from 'braid-design-system';
import { type ComponentProps, useEffect, useState } from 'react';

import { TimeAgo } from './TimeAgo';

type TextProps = ComponentProps<typeof Text>;

interface Props {
  date: string;
  locale: Locale;
  size: TextProps['size'];
  newMessageContent: JSX.Element;
}

export const TimeSinceAdded = ({
  date,
  locale,
  size,
  newMessageContent,
}: Props) => {
  const checkWithinTime = () =>
    new Date().getTime() - new Date(date).getTime() < 10000;

  const [isNew, setIsNew] = useState(checkWithinTime);

  useEffect(() => {
    if (isNew) {
      const timer = setTimeout(() => {
        setIsNew(false);
      }, 5000);
      return () => {
        clearTimeout(timer);
      };
    }
    return;
  }, [isNew]);

  if (!isNew) {
    return (
      <Text tone="secondary" size={size}>
        <TimeAgo date={date} locale={locale} />
      </Text>
    );
  }

  return (
    <Text tone="positive" size={size}>
      {newMessageContent}
    </Text>
  );
};
